//
//
//
//
//
//

export default {
  name: 'm-candidate',
  props: [
    'list',
    'value'
  ],
  methods: {
    onClick (event) {
      this.$emit('input', Number(event.target.dataset.value))
      this.$emit('change', Number(event.target.dataset.value))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Candidate.vue